import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {OperatoriesService} from '../operatories/operatories.service';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {WorkstationConfigurationModel} from '../../../models/configuration/workstation-configuration.model';
import { TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {DevicesService} from '../devices/devices.service';
import {
  DeviceParameters, FolderMonitorParameters,
  WorkstationDevicesConfigurationModel
} from '../../../models/configuration/workstation-devices-configuration.model';
import {SelectDeviceDlgComponent} from './select-device-dlg/select-device-dlg.component';
import {DeviceConfigurationModel} from '../../../models/configuration/device-configuration.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoImagingService} from '../../../main-interface/imaging/tdo-imaging.service';
import {ConfigurationService} from '../configuration.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';

@Component({
  selector: 'app-workstations',
  templateUrl: './workstations.component.html',
  styleUrls: ['./workstations.component.scss']
})
export class WorkstationsComponent implements OnInit {
  @ViewChild('deviceTable') deviceTable: TdoTableV2Component;
  //@ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  devices: any[] = [];

  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];
  operatoriesList: OperatoryDataModel[];
  workstationsList: WorkstationConfigurationModel[];
  workstationsDevicesList: WorkstationDevicesConfigurationModel[];
  deviceCategoryTypesEnums: EnumValidValueItemModel[];
  deviceCategoryEnum: EnumValidValueItemModel;
  devicesTypesEnums: EnumValidValueItemModel[];
  devicesList: DeviceConfigurationModel[];
  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedOperatory: OperatoryDataModel;
  selectedWorkstation: WorkstationConfigurationModel;
  selectedWorkstationKeep: WorkstationConfigurationModel;
  selectedWorkstationDevice: WorkstationDevicesConfigurationModel;
  twainSources: string[];
  selectedTwain = '';
  selectedFolderMonitorName = '';
  editedWorkstations: WorkstationConfigurationModel[] = [];
  editedWorkstationDevices: WorkstationDevicesConfigurationModel[] = [];
  isLoading = true;
  isConnected = true;
  isActive = true;
  isDefault = true;
  isStartFolderMonitor = false;
  isGetWorkstations = true;

  tableModelAttachedDevices: TdoTableModel;
  selectedDevice: DeviceConfigurationModel;
  selectedEnumDeviceTypeID: string;
  enumDeviceTwain: string = '00000261-1000-0000-0000-000000000001';
  enumDeviceServiceBroker: string = '00000261-1000-0000-0000-000000000002';
  public deviceParam: DeviceParameters;
  public folderMonitorParam: FolderMonitorParameters;

  isLoadingOperatories : boolean = true;
  isLoadingLocations : boolean = true;
  isLoadingWorkstationInfo : boolean = true;
  isLoadingWorkstations : boolean = true;
  isLoadingDrivers: boolean = true;

  constructor(private readonly opsService: OperatoriesService,
              private readonly devsService: DevicesService,
              private readonly staticDataService: StaticDataService,
              private readonly drawService: TdoImagingService,
              private readonly globals: Globals,
              private readonly dialogService: DialogService,
              private readonly snackbar: MatSnackBar,
              public configurationService: ConfigurationService,
              private readonly dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.initEnums();
    this.opsService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }
      this.isLoading = false;
      this.changeClient(this.selectedClient);
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }

  onChangeClient(e: TdoDropdownChange): void {
    if (!e.isUserInput) {
      return;
    }

    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(e.value);
          return;
        } else {
          //
        }
      });
    } else {
      this.changeClient(e.value);
    }
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.selectedClient = client;
    this.isLoadingLocations = true;
    this.selectedWorkstation = null;
    this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.isLoadingLocations = false;
      this.locationList = ldata;
      this.operatoriesList = null;
      this.selectedLocation = null;
      if (this.locationList.length > 0) {
        const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
          if (currentLoc) {
            this.selectedLocation = currentLoc;
          } else {
            this.selectedLocation = this.locationList[0];
          }
        this.getDevices();
        const evt = new TdoDropdownChange();
        evt.value = this.selectedLocation;
        evt.isUserInput = true;
        this.onChangeLoc(evt);
      }      
    }, err => {
      console.log(err);
      this.isLoadingLocations = false;
    });
  }

  onChangeLoc(e: TdoDropdownChange) {
    if (!e.isUserInput) {
      return;
    }
    this.selectedLocation = e.value;
    this.operatoriesList = null;
    this.selectedWorkstation = null;
    this.isLoadingOperatories = true;
    this.opsService.getLocationOperatories(this.selectedLocation.LOCID.toString()).subscribe(odata => {
      this.operatoriesList = odata;
      this.selectedOperatory = this.operatoriesList[0];
      this.isLoadingOperatories = false;
      this.getWorkstations();
    
    }, err => {
      console.log(err);
    this.isLoadingOperatories = false;
    });
  }

  getWorkstations() {
    if (this.isGetWorkstations === true) {
      this.isLoadingWorkstations = true;
      this.opsService.getWorkstations(this.selectedLocation.LOCID.toString(), this.selectedOperatory.OperatoryId).subscribe((res) => {
        this.isLoadingWorkstations = false;
        this.workstationsList = res;
        this.workstationsList.sort((a, b) => a.WorkStationName.localeCompare(b.WorkStationName));
        if (this.workstationsList.length > 0) {
          this.selectedWorkstation = this.workstationsList[0];
          this.getAttachedDevices();
        } else {
          this.selectedWorkstation = null;
        }
      });
    }
    else {
      this.selectedWorkstation = this.selectedWorkstationKeep;
    }
  }
  initEnums() {
    if (this.staticDataService.isReady) {
      this.devicesTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceType');
      this.deviceCategoryTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceCategory');
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.devicesTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceType');
          this.deviceCategoryTypesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDeviceCategory');
        }
      });
    }
  }
  getAttachedDevices() {
    this.workstationsDevicesList = [];
    this.devsService.getAttachedDevices(this.selectedWorkstation.WorkStationId.toString()).subscribe(ddata => {
      this.workstationsDevicesList = ddata;
      if (this.workstationsDevicesList.length > 0) {
        this.selectedWorkstationDevice = this.workstationsDevicesList[0];
        this.editedWorkstationDevices = this.workstationsDevicesList;        
      }
      else {
        this.selectedWorkstationDevice = null;
      }
      this.updateWsDeviceList();
    }, err => {
      console.log(err);
      // return false;
    });
  }
  getDevices() {
    this.devsService.getDevices(this.selectedLocation.LOCID.toString()).subscribe(ddata => {
      this.devicesList = ddata;
      // return true;
      // check if using twain
    }, err => {
      console.log(err);
    });
  }
  updateTwainDriverSelection(isUpdate: boolean = true) {
    if (isUpdate === false) {
      return;
    }
    this.selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === this.selectedWorkstationDevice.DeviceID);
    this.selectedEnumDeviceTypeID = this.selectedDevice.enumDeviceTypeID;
    if (this.selectedEnumDeviceTypeID === this.enumDeviceTwain || this.selectedEnumDeviceTypeID === this.enumDeviceServiceBroker) {

      this.drawService.isServiceBrokerRunning(() => {
        console.log('this.drawService.isServiceBrokerRunning', this.drawService.isSBRunning );
        const intervalSubscription = setInterval(_ => {
          if (this.drawService.isSBRunning === true) {
            clearInterval(intervalSubscription);
            if (this.selectedEnumDeviceTypeID === this.enumDeviceTwain) {
              if (this.selectedWorkstationDevice.ParametersJSON) {
                this.selectedTwain = this.getTwainDriverFromJSON(this.selectedWorkstationDevice.ParametersJSON);
              }
              if (!this.twainSources || this.twainSources.length === 0) {
                this.getInstalledTwainDrivers();
              }
            }
          } else {
            clearInterval(intervalSubscription);
            let msg = 'TDOx Service Broker is needed to attach a device to the workstation. \n';
            msg += 'Please download the TDOx Service Broker by clicking on the link below and install.  Refresh the page after installing.';
            this.drawService.scanSetupDlg(msg);
          }
        }, 100);
      });
    }
  }
  getInstalledTwainDrivers() {

    this.isLoadingDrivers = true;
    (this.drawService.scanningService as lt.Scanning.TwainScanning).start(null)
      .done(() => {
        (this.drawService.scanningService as lt.Scanning.TwainScanning).getStatus()
          .done((status) => {
            this.getTwainDrivers(status.selectedSource);
            })
            .fail(() => {
              // Scanning service - getStatus failed
              this.isLoadingDrivers = false;
              (this.drawService.scanningService as lt.Scanning.TwainScanning).start(null)
                .done(() => {
                  (this.drawService.scanningService as lt.Scanning.TwainScanning).getStatus()
                    .done((status) => {
                      this.getTwainDrivers(status.selectedSource);
                    });
                });
            });
      });
  }
  getTwainDrivers(selectedSource: string) {
    // Scanning service - getStatus succeed
    if (!this.selectedTwain) {
      this.selectedTwain = selectedSource;
    }
    this.selectSource();
    if (!this.twainSources || this.twainSources.length === 0) {
      (this.drawService.scanningService as lt.Scanning.TwainScanning).getSources()
        .done((sources) => {
          const scanSource = selectedSource;
          this.twainSources = sources;
          this.isLoading = false;
          // Scanning service - getSources succeed
          let options = '';
          for (const item of sources) {
            if (item === scanSource) {
              options += '<option selected=\'selected\'>' + item + '</option>';
            } else {
              options += '<option>' + item + '</option>';
            }
          }
          this.isLoading = false;
        })
        .fail((ee) => {
          // Scanning service - getSources failed
          // this._errorDlg.show();
          console.log(ee);
          this.isLoading = false;
        });
    }

  }

  updateWsDeviceList(isUpdate: boolean = true) {
    if (this.selectedWorkstationDevice != null) {
      this.deviceCategoryEnum = this.getDeviceTypeById(this.selectedWorkstationDevice.enumDeviceCategoryID);
      this.updateTwainDriverSelection(isUpdate);
      // Folder Monitor Name
      if (this.selectedWorkstationDevice.isStartFolderMonitor === true && this.selectedWorkstationDevice.ParametersJSON.length > 0) {
        this.selectedFolderMonitorName = this.getFolderMonitorNameFromJSON(this.selectedWorkstationDevice.ParametersJSON);
      }
    }
  }
  onNew($event: any) {
    this.addWorkstation();
  }

  onSave($event: any) {
    this.isLoading = true;
    this.opsService.saveWorkstations(this.editedWorkstations).subscribe((res) => {
      if (res) {
        for (const r of res) {
          const currentIdx = this.workstationsList.findIndex(p => p.WorkStationName === r.WorkStationName);
          if (currentIdx > -1) {
            this.workstationsList[currentIdx] = r;
          } else {
            this.workstationsList.push(r);
          }
        }
        this.selectedWorkstation = res[0];
      }

      this.workstationsList.sort((a, b) => a.WorkStationName.localeCompare(b.WorkStationName));

      this.snackbar.open('Workstations saved.', '', {duration: 5000});
      this.isLoading = false;
    });
  }

  addWorkstation() {
    const ws = new WorkstationConfigurationModel();
    ws.OperatoryId = this.selectedOperatory.OperatoryId;
    ws.WorkStationName = 'New Workstation';
    ws.LOCID = this.selectedLocation.LOCID;
    ws.cfgOperatory = this.selectedOperatory;
    this.workstationsList.unshift(ws);
    this.selectedWorkstation = ws;
    this.workstationsDevicesList = [];
  }

  onChangeOperatory(event: TdoDropdownChange) {
    console.log('onChangeOperatory');
     if (!event.isUserInput) {
       return;
     }
     console.log('onChangeOperatory user input', event);
    this.selectedOperatory = event.value;
    this.selectedWorkstation = null;
    this.getWorkstations();
  }

  isWorkstationItemSelected(ws: WorkstationConfigurationModel) {
    return this.selectedWorkstation === ws;
  }

  onWorkstationChanged(ws: WorkstationConfigurationModel) {
    console.log('onWorkstationChanged', ws);
    const devicesOk: boolean = true;
    this.selectedWorkstation = ws;
    this.editedWorkstationDevices = [];
    this.getAttachedDevices();
  }

  onDeleteWorkstation(ws: WorkstationConfigurationModel) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete ' + ws.ComputerName + '?').subscribe((res) => {
      if (res) {
        if (!ws.WorkStationId) {
          const idx1 = this.workstationsList.findIndex(q => q.ComputerName === ws.ComputerName);
          this.workstationsList.splice(idx1, 1);
        } else {
          this.opsService.deleteWorkstation(ws.WorkStationId).subscribe((res1) => {
            //
            const idx = this.workstationsList.findIndex(p => p.WorkStationId === ws.WorkStationId);
            if (idx > -1) {
              this.workstationsList.splice(idx, 1);
            } else {
              const idx1 = this.workstationsList.findIndex(q => q.ComputerName === ws.ComputerName);
              this.workstationsList.splice(idx1, 1);
            }
          });
        }
      }
    });
  }

  onModelChange(selectedWorkstation: WorkstationConfigurationModel) {
    if (!this.editedWorkstations.includes(selectedWorkstation)) {
      this.editedWorkstations.push(selectedWorkstation);
    }
  }

  onWsDeviceModelChange(selectedWsDevice: WorkstationDevicesConfigurationModel) {
    if (this.editedWorkstationDevices !== null) {
      if (!this.editedWorkstationDevices.includes(selectedWsDevice)) {
        this.editedWorkstationDevices.push(selectedWsDevice);
      }
    }
  }

  openDeviceSelector() {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.displayDeviceDlg();
        } else {
          clearInterval(intervalSubscription);
          let msg = 'TDOx Service Broker is needed to attach a device to the workstation. \n';
          msg += 'Please download the TDOx Service Broker by clicking on the link below and install.  Refresh the page after installing.';
          this.drawService.scanSetupDlg(msg);
          return;
        }
      }, 100);
    });

  }
  displayDeviceDlg() {
    const LOCID = this.selectedLocation.LOCID;
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const dialogRef = this.dialog.open(SelectDeviceDlgComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'dialog',
      data: {
        LOCID
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const wsd = new WorkstationDevicesConfigurationModel();
        wsd.WorkStationId = this.selectedWorkstation.WorkStationId;
        wsd.DeviceID = result.DeviceID;
        wsd.Name = result.Name;
        wsd.isConnected = this.isConnected;
        wsd.isActive = this.isActive;
        wsd.isDefault = this.isDefault;
        wsd.enumDeviceCategoryID = emptyGuid;
        if (this.workstationsDevicesList == null) {
          this.workstationsDevicesList = [];
        }
        this.workstationsDevicesList.push(wsd);
        this.selectedWorkstationDevice = wsd;
        this.updateTwainDriverSelection();
        this.onWsDeviceModelChange(wsd);

        if (this.deviceTable !== undefined) {
           this.deviceTable.updateData();
        }
        this.onDeviceCategorySelectionChanged(this.selectedWorkstationDevice.enumDeviceCategoryID);

      }
    }, err => {
      // Error
    });
  }

  getDeviceTypeById(deviceId: string) {
    return this.deviceCategoryTypesEnums.find(p => p.ValidValueItemId === deviceId);
  }
  getDeviceCategoryName(deviceId: string) {
    if (deviceId !== '00000000-0000-0000-0000-000000000000') {
      return this.deviceCategoryTypesEnums.find(p => p.ValidValueItemId === deviceId)?.ItemDisplayValue;
    }
  }
  getDeviceTypeName(deviceId: string) {
    const selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === deviceId);
    return this.devicesTypesEnums.find(p => p.ValidValueItemId === selectedDevice?.enumDeviceTypeID)?.ItemDisplayValue;
  }
  onSaveWorkstationDevice() {
    console.log("onSaveWorkstationDevice");
    this.isLoading = true;
    this.isGetWorkstations = false;
    this.selectedWorkstationKeep = this.selectedWorkstation;
    this.devsService.saveWsDevices(this.editedWorkstationDevices).subscribe((res) => {
      console.log("onSaveWorkstationDevice response: ", res);
      if (res) {
        this.devsService.getAttachedDevices(this.selectedWorkstation.WorkStationId.toString()).subscribe(ddata => {
          this.workstationsDevicesList = ddata;
          if (this.workstationsDevicesList.length > 0) {
            const ivl = setInterval(() => {
              if (this.deviceTable) {
                clearInterval(ivl);
                this.deviceTable.setSelectedModel(this.selectedWorkstationDevice);
              }
            }, 100);
          }
          else {
            this.selectedWorkstationDevice = null;
          }
          this.updateWsDeviceList();
          this.editedWorkstationDevices = [];
          this.onDeviceCategorySelectionChanged(this.selectedWorkstationDevice.enumDeviceCategoryID);

        }, err => {
          console.log(err);
        });
      }
      this.snackbar.open('Workstation-Device saved.', '', {duration: 5000});
      this.isLoading = false;
    });
  }

  onWsDeviceRowSelected(event: TdoTableSelectionEvent) {
    console.log("onWsDeviceRowSelected :", event);
    this.selectedFolderMonitorName = '';
    const selection = this.workstationsDevicesList.find(p => p === event.model);
    this.selectedWorkstationDevice = selection;
    this.onDeviceCategorySelectionChanged(this.selectedWorkstationDevice.enumDeviceCategoryID);
    this.updateTwainDriverSelection();
    if (this.selectedWorkstationDevice.isStartFolderMonitor === true) {
      this.selectedFolderMonitorName = this.getFolderMonitorNameFromJSON(this.selectedWorkstationDevice.ParametersJSON);
    }
  }

  DeleteRowfromEditedWsDevices(row: any) {
    if (this.editedWorkstationDevices !== null) {
      const idx = this.editedWorkstationDevices.findIndex(p => p.Name === row.Name);
      if (idx > -1) {
        this.editedWorkstationDevices.splice(idx, 1);
        if (this.editedWorkstationDevices.length > 0) {
          //
        } else {
          this.editedWorkstationDevices = null;
        }
      }
    }
  }
  DeleteWsDeviceFromDb(row: any)
  {
    this.devsService.deleteWsDevice(row).subscribe((response) => {
    });
  }
  onDeviceCategorySelectionChanged(value: string) {
    this.selectedWorkstationDevice.enumDeviceCategoryID = value;
    this.deviceCategoryEnum = this.getDeviceTypeById(this.selectedWorkstationDevice.enumDeviceCategoryID);
    this.onWsDeviceModelChange(this.selectedWorkstationDevice);
  }


  onWsDeviceTdoTableItemActionClick(action: string, row) {
    const model = (row as WorkstationDevicesConfigurationModel);
    if (action === 'delete') {
      this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.Name}?`).subscribe((result) => {
        if (result === true) {

          const idx = this.workstationsDevicesList.findIndex(p => p.Name === model.Name);
          if (idx > -1) {
            this.DeleteRowfromEditedWsDevices(model);
            this.workstationsDevicesList.splice(idx, 1);
            if (this.workstationsDevicesList.length > 0) {
              this.selectedWorkstationDevice = this.workstationsDevicesList[0];
              this.onDeviceCategorySelectionChanged(this.selectedWorkstationDevice.enumDeviceCategoryID);
              //
            } else {
              this.workstationsDevicesList = [];
              this.selectedWorkstationDevice = new WorkstationDevicesConfigurationModel();
              this.editedWorkstationDevices = [];
            }
          }
          if (this.deviceTable !== undefined) {
            this.deviceTable.updateData();
          }
          this.DeleteWsDeviceFromDb(model);

        } else {
          //
        }
      });
    }
  }
  getTwainDriverFromJSON(paramJson: string) {
    this.deviceParam = JSON.parse(paramJson);
    return this.deviceParam.twainDriver;
  }

  stringifyTwainDriver(twain: string) {
    const devParam = new DeviceParameters();
    devParam.twainDriver = twain;
    return JSON.stringify(devParam);
  }
  getFolderMonitorNameFromJSON(paramJson: string) {
    this.folderMonitorParam = JSON.parse(paramJson);
    return this.folderMonitorParam.MonitorName;
  }

  stringifyFolderMonitorName(folderName: string) {
    const devParam = new FolderMonitorParameters();
    devParam.MonitorName = folderName;
    return JSON.stringify(devParam);
  }

  isServiceBrokerRunning() {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          return;
        } else {
          clearInterval(intervalSubscription);
          let msg = 'TDOx Service Broker is needed to attach a device to the workstation. \n';
          msg += 'Please download the TDOx Service Broker by clicking on the link below and install.  Refresh the page after installing.';
          this.drawService.scanSetupDlg(msg);
          return;
        }
      }, 100);
    });
  }

  selectSource() {
    (this.drawService.scanningService as lt.Scanning.TwainScanning).selectSource(this.selectedTwain)
      .done(() => {
        (this.drawService.scanningService as lt.Scanning.TwainScanning).getStatus()
          .done((status) => {
            // Scanning service - getStatus succeed
            this.selectedTwain = status.selectedSource;
            // this.isConfirmDisabled = false;
            localStorage.setItem('IMAGE_ACQUIRE_TWAIN', JSON.stringify(status.selectedSource));
          })
          .fail(() => {
            // Scanning service - getStatus failed
            (this.drawService.scanningService as lt.Scanning.TwainScanning).start(null)
              .done(() => {
                // this.onSelectSource();
              });
          });
      }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
        alert('selectSource failed');
    })
      .fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
        alert('failed something');
      });
  }
  onFolderMonitorChange(value: string) {
    this.selectedWorkstationDevice.ParametersJSON = this.stringifyFolderMonitorName(value);
    this.onWsDeviceModelChange(this.selectedWorkstationDevice);
  }
  onSelectedTwain(value: string) {
    this.selectedTwain = value;
    this.selectedWorkstationDevice.ParametersJSON = this.stringifyTwainDriver(value);
    this.onWsDeviceModelChange(this.selectedWorkstationDevice);
  }
  OnDefaultChecked($event: MouseEvent) {
    // If selectedWorkstationDevice.isDefault is true set editedWorkstationDevices.isDefault = false except for selectedWorkstationDevice

    if (this.selectedWorkstationDevice.isDefault === true)
    {
      this.editedWorkstationDevices.forEach(obj => {
        if (obj.DeviceID !== this.selectedWorkstationDevice.DeviceID &&
          obj.enumDeviceCategoryID === this.selectedWorkstationDevice.enumDeviceCategoryID)
        {
          obj.isDefault = false;
        }
      });
    }

  }
}
